export const cropImage = (url: string, width = 2500): string => {
    // Handle full Cloudinary URLs
    if (url.includes('res.cloudinary.com')) {
        // Replace /upload/ with /upload/c_scale,w_{width}/ if transformations aren't already present
        // eslint-disable-next-line prefer-named-capture-group, require-unicode-regexp
        const pattern = /(\/upload\/)(?!c_)/;
        const replacement = `/upload/c_scale,w_${width}/`;
        return url.replace(pattern, replacement);
    }

    // Handle relative Cloudinary paths
    return `c_scale,w_${width}/v1/${url}`;
};
